'use client';

import { Box, CircularProgress, TextField } from '@mui/material';
import { useMutation, useQuery } from '@parkchirp/api-client';
import React, { useEffect, useState } from 'react';

import { UPDATE_LEASE_MANAGER_SETTINGS } from '../../../mutations';
import { GET_LEASE_MANAGER_SETTINGS } from '../../../queries';
import { EditorModal } from '../../modals';

interface AbstractModalDocumentProps {
	accountId: number;
	handleClose: () => void;
	theme?: any;
}

export const AbstractModal = ({ accountId, handleClose, theme }: AbstractModalDocumentProps) => {
	const [abstract, setAbstract] = useState('');
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [updateSettings, { loading: updateLoading }] = useMutation(UPDATE_LEASE_MANAGER_SETTINGS);
	const { data, loading } = useQuery(GET_LEASE_MANAGER_SETTINGS, {
		variables: {
			accountId,
		},
		context: {
			apiVersion: 'v2',
		},
		fetchPolicy: 'network-only',
	});
	useEffect(() => {
		if (loading) return;
		if (data?.getLeaseManagerSettings?.abstract) {
			setAbstract(data.getLeaseManagerSettings.abstract);
		}
	}, [data, loading]);
	return (
		<EditorModal
			theme={theme}
			handleClose={handleClose}
			handleSave={() =>
				updateSettings({
					variables: {
						accountId,
						abstract: abstract || null,
					},
					context: {
						apiVersion: 'v2',
					},
				}).then(() => handleClose())
			}
			hasUnsavedChanges={hasUnsavedChanges}
			loading={updateLoading}
			headerText='Lease Manager Abstract'
		>
			<Box
				style={{
					minHeight: '500px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				{loading ? (
					<CircularProgress />
				) : (
					<TextField
						style={{ width: '100%' }}
						id='lease-manager-abstract'
						label='Abstract'
						multiline
						rows={20}
						variant='filled'
						value={abstract}
						onChange={(e) => {
							setHasUnsavedChanges(true);
							setAbstract(e.target.value);
						}}
					/>
				)}
			</Box>
		</EditorModal>
	);
};
